// extracted by mini-css-extract-plugin
module.exports = {"patientInfo":"styles_patientInfo__3Rr6u","listInfo":"styles_listInfo__2_qhD"};